"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOnChannelJoin = useOnChannelJoin;
var _react = require("react");
var _streamChatReact = require("stream-chat-react");
var _lodash = require("lodash");
var _utils = require("../../../utils");
var _ = require("../..");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function useOnChannelJoin(_ref) {
  var _ref$onSuccess = _ref.onSuccess,
    _onSuccess = _ref$onSuccess === void 0 ? _lodash.noop : _ref$onSuccess,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? _lodash.noop : _ref$onError;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var _useChatContext = (0, _streamChatReact.useChatContext)(),
    client = _useChatContext.client,
    setActiveChannel = _useChatContext.setActiveChannel;
  var onJoinToChannel = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(channelId) {
      var channel, updatedChannel;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              channel = (0, _lodash.find)(client.activeChannels, function (_ref3) {
                var id = _ref3.id;
                return id === channelId;
              });
              _context.next = 3;
              return (0, _streamChatReact.getChannel)(client, channel.type, channel.id);
            case 3:
              updatedChannel = _context.sent;
              setActiveChannel(updatedChannel);
            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [client]);
  var _useRequest = (0, _utils.useRequest)(function (channelId) {
      return {
        url: (0, _utils.getChannelMemberUrl)(channelId, user.accountId),
        method: 'post'
      };
    }, {
      manual: true,
      onSuccess: function () {
        var _onSuccess2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return onJoinToChannel(data.channelId);
                case 2:
                  _onSuccess();
                case 3:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        function onSuccess(_x2) {
          return _onSuccess2.apply(this, arguments);
        }
        return onSuccess;
      }(),
      onError: onError
    }),
    loading = _useRequest.loading,
    joinChat = _useRequest.run;
  return {
    joinChat: joinChat,
    loading: loading
  };
}